import {uyapEngelHatasiMi} from "@/plugins/uyap-plugin/UyapEngeli";
import {UYAP_ENGEL_METINLERI} from "@/utils/uyapEngel";

/**
 * Plugin'in engel kancasının gövdesi (kimlikUyusmazligiUyarisiOlustur deseni: saf fabrika, App.vue bağlar).
 *
 * Plugin kancayı yalnız kilit KURULURKEN çağırır (BİR kez); yine de burada tek-uçuş korunur: aynı kilit için ikinci
 * olay pencere/bildirim/ses üretmez. Kilit kalkıp yeniden kurulursa YENİ olaydır (SOZLESME §1.4).
 *
 * Kanca botu DURDURMAZ ve plugin kilidini kurmaz/kaldırmaz: tek sahip plugin `uyapEngeliBotuDurdur`'dur
 * (tanıma anında kendisi dispatch eder; SOZLESME §3.1, C3). Panel sürecinde yerel görev listesine dokunan bir durdurma çağrısı YOK; yalnız (soket bağlıysa) 'durduruluyor' yayını vardır.
 */
export function uyapEngelKancasiOlustur(girdi: {
    store: any;
    pencereAc: () => void;
    bildir: (baslik: string, metin: string) => void;
}): (olay: any) => void {
    return (olay: any) => {
        try {
            // Plugin olayı `UyapEngelBilgisi`: {metin, mesaj (takma ad), zaman, kaynak, ...}; `aktif:false` ana kancaya
            // GELMEZ ama gelirse (tolerans) aynayı temizler.
            if (!olay || olay.aktif === false) {
                girdi.store.commit("setUyapEngeliPanel", null);
                return;
            }
            const zatenVar = girdi.store.getters.uyapEngeliPanel !== null;
            girdi.store.commit("setUyapEngeliPanel", {
                aktif: true,
                zaman: olay.zaman,
                metin: olay.metin !== undefined ? olay.metin : olay.mesaj
            });
            if (zatenVar) return;
            girdi.pencereAc();
            girdi.bildir(UYAP_ENGEL_METINLERI.bildirimBaslik, UYAP_ENGEL_METINLERI.bildirimGovde);
        } catch (e) {
            console.warn("UYAP engeli uyarısı gösterilemedi:", e);
        }
    };
}

/** `unhandledrejection` toast'ı en çok bu aralıkta bir kez (SOZLESME §13.8, S8). */
export const KAPI_REDDI_TOAST_ARALIGI_MS = 10000;

/**
 * YAKALANMAMIŞ engel/kapı reddi için kısa toast (SOZLESME §13.8, S8). Hatayı yakalayan akışlar kendi
 * `toast.error(e.message)`'ını gösterir (kapı mesajı zaten K8 metnidir); `$uyap` çağıran çok sayıda dosyanın çoğu
 * yakalamadığı için sessiz kalanlara tek dinleyici: YALNIZ `uyapEngelHatasiMi(reason)` olan hatalar (başka
 * yakalanmamış reddedilmelere dokunulmaz), en çok `aralikMs`'de bir (varsayılan 10 sn), yalnız sekme görünürken.
 * Pencere AÇMAZ.
 */
export function kapiReddiToastiOlustur(girdi: {
    toast: any;
    simdi?: () => number;
    aralikMs?: number;
    gorunurMu?: () => boolean;
}): (olay: any) => void {
    const saat = girdi.simdi || (() => Date.now());
    const aralik = girdi.aralikMs === undefined ? KAPI_REDDI_TOAST_ARALIGI_MS : girdi.aralikMs;
    const gorunur = girdi.gorunurMu || (() => typeof document === "undefined" || document.visibilityState !== "hidden");
    let son = -Infinity;
    return (olay: any) => {
        const hata = olay && olay.reason;
        if (!hata || !uyapEngelHatasiMi(hata)) return;
        if (!gorunur()) return;
        const simdi = saat();
        if (simdi - son < aralik) return;
        son = simdi;
        try {
            girdi.toast.error(UYAP_ENGEL_METINLERI.kapiToast);
        } catch (e) {
            console.warn("UYAP engeli toast'ı gösterilemedi:", e);
        }
    };
}
